import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { EmotionalHook } from './components/EmotionalHook';
import { PainPoints } from './components/PainPoints';
import { Benefits } from './components/Benefits';
import { RecipeShowcase } from './components/RecipeShowcase';
import { DevicePreview } from './components/DevicePreview';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { ValueOffer } from './components/ValueOffer';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-warm-white font-sans text-espresso selection:bg-terracotta/30 selection:text-espresso" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <EmotionalHook data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Benefits data-id="element-6" />
        <RecipeShowcase data-id="element-7" />
        <DevicePreview data-id="element-8" />
        <WhoIsThisFor data-id="element-9" />
        <ValueOffer data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}